// ErrorCard.tsx
import { ClockCircleOutlined } from '@ant-design/icons';
import { toAbsoluteUrl } from '@app/utils/toAbsoluteUrl';
import { Button } from 'antd';
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

const ErrorCard: React.FC<{ onClick: () => void }> = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen w-screen flex flex-col items-center justify-center bg-app-primary-600 px-6 py-10">
      <img alt="Logo" src={toAbsoluteUrl('media/logos/logo_light.png')} className="h-[56px] mb-10" />

      <div className="w-full max-w-md bg-white rounded-2xl shadow-xl px-8 py-10 flex flex-col items-center text-center">
        <div className="flex items-center justify-center h-16 w-16 rounded-full bg-app-primary-50 mb-6">
          <ClockCircleOutlined style={{ fontSize: 28, color: 'var(--color-app-primary-500)' }} />
        </div>

        <h1 className="text-2xl font-semibold text-gray-900 mb-2">{t('auth-required-title')}</h1>
        <p className="text-gray-500 mb-8 leading-relaxed">{t('auth-session-expired')}</p>

        <Button type="primary" size="large" onClick={onClick} block>
          {t('auth-sign-in')}
        </Button>
      </div>
    </div>
  );
};

export default memo(ErrorCard);
